import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Input from '../../../components/v2/Input'
import Loader from '../../../components/Loader'
import Dropdown from '../../../components/v2/Dropdown'
import GenderCard from '../../../components/v2/GenderCard'
import Title from '../../../components/v2/Title'
import WarningMessage from '../../../components/v2/WarningMessage'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import UploadFile from '../../../components/UploadFile'
import Col from 'react-bootstrap/esm/Col'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../store'
import { setForWho, setInsured, CriticalIllnessState } from '../../../store/criticalIllnessSlice'
import { CriticalIllnessForMePersonalInfo } from '../../../domain/types'
import { useFieldArray, useForm } from 'react-hook-form'
import api from '../../../api'
import Checkbox from '../../../components/v2/buttons/Checkbox'
import AddButton from '../../../components/v2/buttons/AddButton'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import CloseIcon from '../../../assets/icons/JSX/CloseIcon'
import CriticalProgressbar from '../../../components/v2/progrees-bars/CriticalProgressbar'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import { AppState } from '../../../store/appSlice'

const CriticalForMeAndOther = () => {
  //
  // countries array from api
  const { data: countries, isLoading: isCountriesLoading } = api.useGetCountriesQuery(undefined)
  //
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  const [activeCheckbox, setActiveCheckbox] = useState(false)
  //
  const dispatch = useAppDispatch()
  //
  const { checkout, filter, screenHeader } = useAppSelector((data: { critical: CriticalIllnessState }) => data.critical)
  //
  const { data: pageInfo, isLoading: isPageInfoLoading } = api.useGetPetPageInfoQuery('critical-your-personal-info')
  //
  const pageTitle = pageInfo?.translations?.[lang]?.title
  const stepName = pageInfo?.translations?.[lang]?.stepName
  //
  //
  //
  const [insuredCountState] = useState<number | undefined>(filter.insuredInfo?.length)

  // insured array
  const [insuredInfo, setInsuredInfo] = useState<Partial<CriticalIllnessForMePersonalInfo>[]>(
    checkout.insured
      ? checkout.insured
      : [
          {
            cityzenship: 'GE',
            idNumber: '',
            email: '',
            dateOfbirth: null,
            gender: '',
            sgsVerification: false,
            sgsVerificationSended: false,
            translations: {
              ge: {
                firstName: '',
                lastName: '',
              },
              en: {
                firstName: '',
                lastName: '',
              },
            },
          },
        ],
  )
  //
  //
  type CriticalPersonalInfos = {
    UserPersonalInfos: Partial<CriticalIllnessForMePersonalInfo>[]
  }
  //
  //
  const insuredAgeFromRedux = filter.insuredInfo?.map((x, i) => `${x.date}-${i}`)
  //
  const incomeDateCounts = {}
  insuredAgeFromRedux?.forEach(function (x) {
    // @ts-ignore
    incomeDateCounts[x] = (incomeDateCounts[x] || 0) + 1
  })
  //
  //
  const insuredDateFromCurrentPage = insuredInfo?.map((x) => x.dateOfbirth)
  //
  const currentDateCounts = {}
  insuredDateFromCurrentPage?.forEach(function (x) {
    // @ts-ignore
    currentDateCounts[x] = (currentDateCounts[x] || 0) + 1
  })
  //
  // check user dates
  const isDeepEqual = (object1: any, object2: any) => {
    const objKeys1 = Object.keys(object1)
    const objKeys2 = Object.keys(object2)

    if (objKeys1.length !== objKeys2.length) return false

    for (var key of objKeys1) {
      const value1 = object1[key]
      const value2 = object2[key]

      const isObjects = isObject(value1) && isObject(value2)

      if ((isObjects && !isDeepEqual(value1, value2)) || (!isObjects && value1 !== value2)) {
        return false
      }
    }
    return true
  }
  //
  const isObject = (object: any) => {
    return object != null && typeof object === 'object'
  }
  // dates equal variable
  const isInsuredDateEqual: boolean = isDeepEqual(incomeDateCounts, currentDateCounts)
  //
  //
  //
  const NextStep = () => {
    if (checkout.forWho === 'for-me') {
      return [navigate('/critical-check-information'), dispatch(setInsured(insuredInfo))]
    }
    //
    if (checkout.forWho === 'for-other') {
      return [navigate('/critical-insurer'), dispatch(setInsured(insuredInfo))]
    }
    //
    if (checkout.forWho === 'for-me-and-other') {
      return [navigate('/critical-check-information'), dispatch(setInsured(insuredInfo))]
    }
  }
  //
  //
  const onSubmit = (userPersonalInfos: CriticalPersonalInfos, event: any) => {
    event.preventDefault()
    setInsuredInfo(userPersonalInfos.UserPersonalInfos)
    NextStep()
  }

  //
  const [openAccordion, setOpenAccordion] = useState<number | null>(0)
  //
  const insurerRef = useRef<HTMLDivElement | null>(null)
  //

  const _toggleAccordion = (index: number) => {
    if (openAccordion === index) {
      setOpenAccordion(null) // Close the currently open accordion
    } else {
      setOpenAccordion(index) // Open the clicked accordion
    }
  }

  //
  //
  //
  const handleAddInsurer = () => {
    append({
      id: 0,
      cityzenship: 'GE',
      passportNumber: '',
      idNumber: '',
      email: '',
      dateOfbirth: null,
      gender: '',
      sgsVerification: false,
      sgsVerificationSended: false,
      translations: {
        ge: {
          firstName: '',
          lastName: '',
        },
        en: {
          firstName: '',
          lastName: '',
        },
      },
    })
  }

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm<CriticalPersonalInfos>({ defaultValues: { UserPersonalInfos: insuredInfo }, mode: 'all' })
  //
  const { append, remove } = useFieldArray({
    control: control,
    name: 'UserPersonalInfos',
    rules: {
      required: { value: true, message: 'Add At least one field' },
    },
  })

  //
  const handleKeyDown = (event: any) => {
    if (event?.key === 'Enter') {
      event.preventDefault()
    }
  }

  //
  const hasDuplicates = (arr: string[]) => {
    let set = new Set()
    for (let item of arr) {
      if (set.has(item) && item.trim().length >= 2) {
        return true
      } else {
        set.add(item)
      }
    }
    return false
  }
  //
  //
  const insurerPersonalNumbers = insuredInfo?.map((x) => x?.idNumber)

  //
  const data = watch('UserPersonalInfos')

  useEffect(() => {
    setInsuredInfo(data)
  }, [data])
  //
  //
  const handleInsurerCityzenship = (fieldName: string, value: any, index: any) => {
    setValue(`UserPersonalInfos.${index}.cityzenship`, value)
  }

  //
  // splittin image url for showing in the box as title
  const splittingImageTitle = (image: any) => {
    const url: string | URL = image

    const pathName = new URL(url).pathname

    const pathSegments = pathName.split('/')

    const fileName = pathSegments[pathSegments.length - 1]

    const titleSegment = fileName.split('-')

    const title = titleSegment.slice(1).join('-')

    return title
  }
  //
  // compare dates in dropdown and in insured info and the declaring id in personal info
  const checkWhichDate = (value: any, index: any) => {
    const selectedDate = value

    const splitDate = selectedDate.split('-')

    const date = splitDate[0]

    const selectedInfo = filter?.insuredInfo?.find((x) => x.date === date)

    if (selectedInfo) {
      setValue(`UserPersonalInfos.${index}.id`, selectedInfo.id)
    }
  }
  //
  //
  // english letter regex
  const englishLetterRegex = /^[A-Za-z]+$/
  // georgian letter regex
  const georgianLetterRegex = /^[\u10D0-\u10FF]*$/
  //
  //
  // declaring insurance type if someone visits via url
  useEffect(() => {
    dispatch(setForWho('for-me-and-other'))
  }, [dispatch])
  //
  //
  const MainLoading = isCountriesLoading || isPageInfoLoading

  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={pageTitle} />

        <CriticalProgressbar stepName={stepName} />

        {insuredInfo?.map((item, index) => {
          return (
            <WhiteBox key={index} ref={insurerRef}>
              <BlockHead>
                <CloseButton onClick={() => _toggleAccordion(index)}>
                  <RightArrow
                    style={{
                      transform: openAccordion === index ? `rotate(0deg)` : `rotate(-180deg)`,
                    }}
                  />
                </CloseButton>

                <BoxTitle onClick={() => _toggleAccordion(index)}>
                  {index === 0 ? `${t('insurerInformation')}` : `${t('insured')}`} {index >= 1 ? index + 1 : null}
                </BoxTitle>

                <RemoveBtn
                  style={{
                    pointerEvents: index === 0 ? 'none' : 'unset',
                    userSelect: index === 0 ? 'none' : 'unset',
                    opacity: index === 0 ? '0' : 'unset',
                  }}
                  type="button"
                  onClick={() => remove(index)}
                >
                  <CloseIcon />
                </RemoveBtn>
              </BlockHead>

              {openAccordion === index ? (
                <Inputs>
                  {countries && (
                    <Dropdown
                      title={`${t('cityzenship')}`}
                      isSearchable={true}
                      value={item.cityzenship || ''}
                      options={[
                        ...countries.map((c) => ({
                          value: c.isoCode,
                          label: c.translations?.[lang]?.name,
                        })),
                      ]}
                      isDisabled={
                        // (auth?.user?.citizenship && auth.user?.userType === 'User') ||
                        // (checkout.insurer.sgsVerification === true && checkout.insurer.cityzenship)
                        //   ? true
                        //   :
                        false
                      }
                      onChange={(value) => handleInsurerCityzenship('cityzenship', value.value, index)}
                    />
                  )}

                  <Input
                    id={`critical-id-number-${index}`}
                    name={`UserPersonalInfos.${index}.idNumber`}
                    label={`${t('personalNumber')}`}
                    type="text"
                    placeholder=""
                    value={item.idNumber}
                    width={'fullWidth'}
                    error={!!errors.UserPersonalInfos?.[index]?.idNumber}
                    errorText={errors.UserPersonalInfos?.[index]?.idNumber?.message}
                    formRegistration={register(`UserPersonalInfos.${index}.idNumber`, {
                      minLength: item.cityzenship === 'GE' ? { value: 11, message: `${t('required')}` } : undefined,
                      maxLength:
                        item.cityzenship === 'GE'
                          ? { value: 11, message: `${t('personalNumberValidation')}` }
                          : undefined,
                      pattern: { value: /^\S*$/, message: `${t('spaceValidation')}` },
                    })}
                    onKeyPress={handleKeyDown}
                  />

                  {hasDuplicates(insurerPersonalNumbers as string[]) && (
                    <WarningMessage variant="gray" text={t('duplicatePersonalNumber')} />
                  )}

                  {filter && filter.insuredInfo && (
                    <Dropdown
                      title={`${t('dateOfBirth')}`}
                      isSearchable={false}
                      value={watch(`UserPersonalInfos.${index}.dateOfbirth`) || ''}
                      options={[
                        ...filter?.insuredInfo?.map((t, i) => ({
                          value: `${t.date}-${i}`,
                          label: t.date,
                        })),
                      ]}
                      onChange={(event) => [
                        setValue(`UserPersonalInfos.${index}.dateOfbirth`, event.value),
                        checkWhichDate(event.value, index),
                        setValue(
                          `UserPersonalInfos.${index}.gender`,
                          filter.insuredInfo?.find((x) => x.id === item.id && x.gender === 'female')
                            ? 'female'
                            : 'male',
                        ),
                      ]}
                    />
                  )}

                  {item.cityzenship === 'GE' && (
                    <>
                      <Input
                        id={`critical-firstName-georgian-${index}`}
                        name={`UserPersonalInfos.${index}.translations.ge.firstName`}
                        label={`${t('nameInGeorgia')}`}
                        type="text"
                        placeholder=""
                        value={item.translations?.ge?.firstName}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.firstName?.message}
                        onKeyPress={handleKeyDown}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.ge.firstName`, {
                          pattern: {
                            value: georgianLetterRegex,
                            message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                        })}
                      />
                      <Input
                        id={`critical-lastName-georgian-${index}`}
                        name={`UserPersonalInfos.${index}.translations.ge.lastName`}
                        label={`${t('surnameInGeorgia')}`}
                        type="text"
                        placeholder=""
                        value={item.translations?.ge?.lastName}
                        width={'fullWidth'}
                        error={!!errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName}
                        errorText={errors.UserPersonalInfos?.[index]?.translations?.ge?.lastName?.message}
                        onKeyPress={handleKeyDown}
                        formRegistration={register(`UserPersonalInfos.${index}.translations.ge.lastName`, {
                          pattern: {
                            value: georgianLetterRegex,
                            message: `${t('enterGeorgianLetterAndRemoveSpaceValidation')}`,
                          },
                          minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                        })}
                      />
                    </>
                  )}

                  <Input
                    id={`critical-fistName-english${index}`}
                    name={`UserPersonalInfos.${index}.translations.en.firstName`}
                    label={`${t('nameInEnglish')}`}
                    type="text"
                    placeholder=""
                    value={item.translations?.en?.firstName}
                    width={'fullWidth'}
                    error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.firstName}
                    errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.firstName?.message}
                    onKeyPress={handleKeyDown}
                    formRegistration={register(`UserPersonalInfos.${index}.translations.en.firstName`, {
                      pattern: {
                        value: englishLetterRegex,
                        message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                      },
                      minLength: { value: 2, message: `${t('minNameLetterLenght')}` },
                    })}
                  />

                  <Input
                    id={`critical-lastName-english${index}`}
                    name={`UserPersonalInfos.${index}.translations.en.lastName`}
                    label={`${t('surnameInEnglish')}`}
                    type="text"
                    placeholder=""
                    value={item?.translations?.en?.lastName}
                    width={'fullWidth'}
                    error={!!errors.UserPersonalInfos?.[index]?.translations?.en?.lastName}
                    errorText={errors.UserPersonalInfos?.[index]?.translations?.en?.lastName?.message}
                    onKeyPress={handleKeyDown}
                    formRegistration={register(`UserPersonalInfos.${index}.translations.en.lastName`, {
                      pattern: {
                        value: englishLetterRegex,
                        message: `${t('enterEnglishLetterAndRemoveSpaceValidation')}`,
                      },
                      minLength: { value: 2, message: `${t('minSurnameLetterLenght')}` },
                    })}
                  />

                  <ChooseGenderLabel>{t('chooseGender')}</ChooseGenderLabel>
                  <GenderBlock>
                    <GenderCard
                      selected={
                        filter.insuredInfo?.find((x) => x.id === item.id && x.gender === 'female') ? true : false
                      }
                      gender="female"
                      femaleText={`${t('female')}`}
                      onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'female')}
                    />

                    <GenderCard
                      selected={filter.insuredInfo?.find((x) => x.id === item.id && x.gender === 'male') ? true : false}
                      gender="male"
                      maleText={`${t('male')}`}
                      onClick={() => setValue(`UserPersonalInfos.${index}.gender`, 'male')}
                    />
                  </GenderBlock>

                  <>
                    <hr />
                    <BoxTitle>{t('yourID')}</BoxTitle>
                    <Col>
                      <UploadFile
                        style={{ marginBottom: '24px' }}
                        label={t('side1')}
                        onChange={(value) => setValue(`UserPersonalInfos.${index}.IdImageFront`, value)}
                        defaultFileName={item.IdImageFront ? splittingImageTitle(item.IdImageFront) : ''}
                      />
                    </Col>
                    <Col>
                      <UploadFile
                        label={t('side2')}
                        onChange={(value) => setValue(`UserPersonalInfos.${index}.IdImageBack`, value)}
                        defaultFileName={item.IdImageBack ? splittingImageTitle(item.IdImageBack) : ''}
                      />
                    </Col>
                  </>

                  <hr />
                  <Checkbox
                    id={`UserPersonalInfos.${index}.insuredRecently`}
                    label={t('beenInsuredRecently')}
                    defaultChecked={watch(`UserPersonalInfos.${index}.insuredRecently`) === true}
                    onClick={() => [
                      setActiveCheckbox(!activeCheckbox),
                      setValue(`UserPersonalInfos.${index}.insuredRecently`, !activeCheckbox),
                    ]}
                  />

                  {/*  */}
                </Inputs>
              ) : null}
            </WhiteBox>
          )
        })}

        {(insuredCountState && insuredInfo && insuredInfo.length === insuredCountState) ||
        (insuredCountState && insuredInfo && insuredInfo.length > insuredCountState) ? null : (
          <AddButtonStyle>
            <AddButton
              text={t('addInsured')}
              onClick={() => [handleAddInsurer(), _toggleAccordion((openAccordion as number) + 1)]}
            />
          </AddButtonStyle>
        )}

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => navigate('/critical-who-do-you-insure')}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={isInsuredDateEqual ? false : true}
            onClick={handleSubmit(onSubmit)}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}

//

const BlockHead = styled.div`
  display: flex;
  align-items: center;
`
const RemoveBtn = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  position: absolute;
  top: 16px;
  right: 16px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 16px;
    height: 13px;
    color: ${Colors.nevadaGrey};
  }

  ${Responsive.mobile} {
    svg {
      width: 14px;
      height: 11px;
    }
  }
`
const CloseButton = styled.button`
  background-color: transparent;
  border: unset;
  outline: unset;
  padding: 5px;
  margin: 0px;
  display: grid;
  place-items: center;
  transform: rotate(-90deg);
  position: absolute;
  left: 14px;

  &:active {
    opacity: 0.8;
  }

  svg {
    width: 17px;
    height: 14px;
    color: ${Colors.primaryBlack};
  }

  ${Responsive.mobile} {
    left: 12px;
  }
`
const AddButtonStyle = styled.div`
  margin-top: 60px;
  display: grid;
  place-items: center;
`
const GenderBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
`
const ChooseGenderLabel = styled.label`
  font-size: 14px;
  color: ${Colors.primaryGrey};
`
const Inputs = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  margin-top: 20px;
`
const WhiteBox = styled.div`
  position: relative;
  background-color: ${Colors.white};
  margin-block: 32px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  max-width: 464px;
  margin-inline: auto;
  border-radius: 8px;
  padding: 34px 48px;

  ${Responsive.mobile} {
    padding: 25px 20px;
    width: 100%;
  }
`

const BoxTitle = styled.h6`
  font-size: 18px;
  color: ${Colors.primaryBlack};

  ${Responsive.mobile} {
    padding-left: 20px;
  }
`

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  width: min-content;
  margin-top: 48px;
  margin-inline: auto;
  button {
    width: 175px;
  }

  ${Responsive.mobile} {
    margin-top: 40px;
    gap: 16px;
    button {
      width: 140px;
    }
  }
`
const Content = styled.div`
  position: relative;
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  /*  */
`

export default CriticalForMeAndOther
